/**
 * StatusBar Component
 * Bottom status bar for the DAW
 * Extracted from DAWWorkspace.jsx for better modularity
 */

export const StatusBar = ({
  sampleRate = 44100,
  trackCount = 0,
  bpm = 120,
  sessionId = null,
  projectStatus = 'ready',
}) => {
  return (
    <footer className="h-8 bg-zinc-900/80 border-t border-zinc-800 px-4 flex items-center justify-between text-xs text-zinc-500 flex-shrink-0">
      <div className="flex items-center gap-2">
        <div className={`w-2 h-2 rounded-full ${
          projectStatus === 'saving' ? 'bg-amber-500 animate-pulse' :
          projectStatus === 'error' ? 'bg-red-500' :
          'bg-emerald-500'
        }`} />
        <span>String Sauce</span>
        {sessionId && (
          <span className="text-emerald-400">• Live: {sessionId}</span>
        )}
      </div>
      <div className="flex items-center gap-3">
        <span className="font-mono">{sampleRate}Hz</span>
        <span className="text-zinc-600">•</span>
        <span>{trackCount} tracks</span>
        <span className="text-zinc-600">•</span>
        <span className="font-mono">{bpm} BPM</span>
      </div>
    </footer>
  );
};

export default StatusBar;
